import React from "react";
import {
  Box,
  Flex,
  Text,
  Divider,
  Heading,
  Icon,
  Modal as CkModal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import { theme } from "src/styles/theme";
import {
  BsBank,
  BsCalendar4Event,
  BsCalendarCheck,
  BsClockHistory,
  BsPlusLg,
} from "react-icons/bs";
import Tab from "@components/Sales/Tab";
import ActivityComponent from "../ActivityComponent";
import Button from "@components/common/Button";
import Modal from "@components/Sales/Modal";
import CreateScheduleComponent from "../Schedule/CreateScheduleComponent";
import ButtonPopover from "@components/Sales/ButtonPopover";
import DetailComponent from "./DetailComponent";
import CreateTaskCallComponent from "../TasksCalls/CreateTaskCallComponent";
import { OportunityContext } from "@context/oportunityContex";
import CreateCreditRatingComponent from "../CreditRating/CreateCreditRatingComponent";
import {
  MdOutlineSpatialAudioOff,
  MdChecklist,
  MdOutlineAttachMoney,
} from "react-icons/md";
import { IoDocumentTextOutline, IoTrashOutline } from "react-icons/io5";
import Stepp from "@components/Sales/Stepp";
import type {
  IDetailOportunityComponent,
  IHashMapKeyString,
} from "src/@types/Sales";
import ViewCreditRatingComponent from "../CreditRating/ViewCreditRatingComponent";
import ContractsComponent from "../Contracts/ContractsComponent";
import { RxUpdate } from "react-icons/rx";
import oportunityServiceInstance from "@services/Oportunity/OportunityService";
import QuotesComponent from "../Quotes/QuotesComponent";
import ViewQuotesComponent from "../Quotes/ViewQuotesComponent";
import Spinner from "@components/common/Spinner";
import CreateQuotesComponent from "../Quotes/CreateQuotesComponent";
import RelationshipComponent from "../Relationship/RelationshipComponent";
import CreditRatingComponent from "../CreditRating/CreditRatingComponent";
import InputSelect from "@components/Sales/Inputs/InputSelect";
import { optionCloseLose } from "@helpers/optionSelect";
import { useMessageErrorToast } from "@hook/useMessageErrorToast";
import { useMessageToast, useOnlyMessageToast } from "@hook/useMessageToast";
import { IconMail } from "src/assets/iconMail";
import { IconCall } from "src/assets/iconCall";
import { FaAward } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UsuallyContext } from "@context/usuallyContex";
import { IconUnranked } from "src/assets/iconUnranked";
import { TbCalendarPlus } from "react-icons/tb";
import { FaRegSquareCheck } from "react-icons/fa6";
import { handleDefaultRanking } from "@helpers/defaultValues";
import { cookieKeys, getCookie } from "@helpers/cookies";

const DetailOportunityComponent = () => {
  const navigate = useNavigate();
  const { id: oportunidadeId } = useParams<{ id: string }>();
  const { hashDetailOportunity, setHashDetailOportunity } =
    React.useContext(UsuallyContext);
  const {
    accessCreateOp,
    setAccessCreateOp,
    indexTabDetails,
    setIndexTabDetails,
  } = React.useContext(OportunityContext);

  const handleNavigationCreateAccount = () => {
    navigate("/oportunidades");
  };

  // Atualizar o contexto com o ID da oportunidade da URL
  React.useEffect(() => {
    if (
      oportunidadeId &&
      (!accessCreateOp.oportunidadeId ||
        accessCreateOp.oportunidadeId !== oportunidadeId)
    ) {
      setAccessCreateOp((prev) => ({
        ...prev,
        oportunidadeId: oportunidadeId,
      }));
    }
  }, [oportunidadeId, accessCreateOp.oportunidadeId, setAccessCreateOp]);

  return (
    <DetailOportunityComponentOriginal
      hash={hashDetailOportunity}
      setHash={setHashDetailOportunity}
      navigationCreateAccount={handleNavigationCreateAccount}
      index={indexTabDetails}
      setIndex={setIndexTabDetails}
    />
  );
};

export default React.memo(DetailOportunityComponent);

const DetailOportunityComponentOriginal = ({
  hash = "DetailOportunity",
  setHash,
  navigationCreateAccount,
  index,
  setIndex,
}: IDetailOportunityComponent) => {
  const idCorretor = getCookie(cookieKeys.idCorretor) || "";
  const location = useLocation();
  const routeState = location.state;
  const displayMessageError = useMessageErrorToast();
  const displayMessage = useOnlyMessageToast();
  const displayMessageCreateCall = useMessageToast();
  const {
    faseOp,
    accountIdSalesforce,
    opportunityId,
    opportunityName,
    accessCreateOp,
    setAccessCreateOp,
    contracts,
    setLoading,
    setContracts,
    setOnboardingDocuments,
    setAccessQuote,
    accessAttachments,
    setDisabledCreateDocument,
    setRegionalOp,
    setFaseOp,
    ranking,
    setRanking,
    hashCreateQuote,
    setAccessTasksCalls,
    setCreateTaskOrCall,
  } = React.useContext(OportunityContext);
  const [modalSchedule, setModalSchedule] = React.useState(false);
  const [successCreateSchedule, setSuccessCreateSchedule] =
    React.useState(false);
  const [successCreateTaskCall, setSuccessCreateTaskCall] =
    React.useState(false);
  const [modalTaskCall, setModalTaskCall] = React.useState(false);
  const [modalCreditRating, setModalCreditRating] = React.useState(false);
  const [successCreateCreditRating, setSuccessCreateCreditRating] =
    React.useState(false);
  const [updateData, setUpdateData] = React.useState({ data: "" });
  const [edit, setEdit] = React.useState(false);
  const [currentFase, setCurrentFase] = React.useState("");
  const [isEditQuote, setIsEditQuote] = React.useState(false);
  const [canEditQuote, setCanEditQuote] = React.useState(false);
  const [loadingGetOportunity, setloadingGetOportunity] = React.useState(false);
  const [dataOportunidade, setDataOportunidade] = React.useState("");
  const [probabilidade, setProbabilidade] = React.useState("");
  const [modalQuot, setModalQuot] = React.useState(false);
  const [successCreateQuote, setSuccessCreateQuote] = React.useState(false);

  const [showDetailTaskCall, setShowDetailTaskCall] = React.useState(false);
  const [showDetailSchedule, setShowDetailSchedule] = React.useState(false);
  const [cancelButtonAdress, setCancelButtonAdress] = React.useState(false);
  const [showCloseLose, setShowCloseLose] = React.useState(false);
  const [reason, setReason] = React.useState("");
  const [loadingCloseLose, setLoadingCloseLose] = React.useState(false);
  const [reasonNumber, setReasonNumber] = React.useState(0);
  const [allowedDrop, setAllowedDrop] = React.useState(false);
  const [emailOp, setEmailOp] = React.useState("");
  const [telephoneOp, setTelephoneOp] = React.useState("");
  const [loadingCreateCall, setLoadingCreateCall] = React.useState(false);
  const [openModalRanking, setOpenModalRanking] = React.useState(false);
  const [hashRanking, setHashRanking] = React.useState("Inicial");
  const [loadingUpdateRank, setLoadingUpdaterank] = React.useState(false);
  const [cpfCnpj, setCpfCnpj] = React.useState("");
  const [newRanking, setNewRanking] = React.useState("");

  let contractsTitle = "Contratos";
  if (contracts.length > 0) {
    contractsTitle += ` (${contracts.length})`;
  }
  const tabLabels = [
    "Oportunidade",
    "Compradores",
    "Tarefas e agendamentos",
    "Avaliações de crédito",
    "Cotações",
    contractsTitle,
  ];
  const tabContents = {
    Oportunidade: (
      <DetailComponent
        setCpfCnpj={setCpfCnpj}
        setEmailOp={setEmailOp}
        setTelephoneOp={setTelephoneOp}
        indexFirstTab={index}
        edit={edit}
        setEdit={setEdit}
        setCurrentFase={setCurrentFase}
        updateData={updateData}
        setDataOportunidade={setDataOportunidade}
        loadingGetOportunity={loadingGetOportunity}
        setloadingGetOportunity={setloadingGetOportunity}
        setProbabilidade={setProbabilidade}
        cancelButtonAdress={cancelButtonAdress}
        setCancelButtonAdress={setCancelButtonAdress}
        setAllowedDrop={setAllowedDrop}
        //dropdown do acesso rapido
        setModalSchedule={setModalSchedule}
        setModalTaskCall={setModalTaskCall}
        setShowCloseLose={setShowCloseLose}
        setModalQuot={setModalQuot}
        setShowDetailTaskCall={setShowDetailTaskCall}
      />
    ),
    Compradores: (
      <RelationshipComponent
        indexFirstTab={index}
        navigationCreateAccount={navigationCreateAccount}
        setCpfCnpj={setCpfCnpj}
      />
    ),
    "Tarefas e agendamentos": (
      <ActivityComponent
        indexFirstTab={index}
        successCreateSchedule={successCreateSchedule}
        navigateCreateSchedule={() => setModalSchedule(true)}
        navigateCreateTask={() => setModalTaskCall(true)}
        successCreateTaskCall={successCreateTaskCall}
        updateData={updateData}
        showDetailTaskCall={showDetailTaskCall}
        setShowDetailTaskCall={setShowDetailTaskCall}
        showDetailSchedule={showDetailSchedule}
        setShowDetailSchedule={setShowDetailSchedule}
      />
    ),
    "Avaliações de crédito": (
      <CreditRatingComponent
        index={index}
        navigateCreateCreditRating={() => setModalCreditRating(true)}
        successCreateCreditRating={successCreateCreditRating}
        setHashCreateCreditRating={setHash}
        updateData={updateData}
      />
    ),
    Cotações: (
      <QuotesComponent
        indexFirstTab={index}
        setHash={setHash}
        setIsEdit={setIsEditQuote}
        navigateCreateQuote={() => setModalQuot(true)}
        setCanEdit={setCanEditQuote}
        successCreateQuote={successCreateQuote}
        setSuccessCreateQuote={setSuccessCreateQuote}
        updateData={updateData}
      />
    ),
    [contractsTitle]: <ContractsComponent />,
  };

  const arrayButtons = [
    {
      icon: <FaRegSquareCheck fontSize={"18px"} />,
      title: `Criar tarefa`,
      onClick: () => setModalTaskCall(true),
    },
    {
      icon: <TbCalendarPlus fontSize={"18px"} />,
      title: `Criar agendamento`,
      onClick: () => setModalSchedule(true),
    },
    {
      icon: <MdOutlineAttachMoney fontSize={"18px"} />,
      title: `Consultar status CPF`,
      onClick: () => setOpenModalRanking(true),
    },
    {
      icon: <IoTrashOutline fontSize={"18px"} />,
      title: `Fechar e perder oportunidade`,
      onClick: () => setShowCloseLose(true),
    },
  ];

  const steps = [
    {
      title: "Aguardando atendimento",
      icon: <BsClockHistory fontSize={"20px"} />,
      states: ["aguardando atendimento corretor"],
    },
    {
      title: "Em atendimento",
      icon: <MdOutlineSpatialAudioOff fontSize={"20px"} />,
      states: ["em atendimento"],
    },
    {
      title: "Visita agendada",
      icon: <BsCalendar4Event fontSize={"20px"} />,
      states: ["visita agendada"],
    },
    {
      title: "Visita realizada",
      icon: <BsCalendarCheck fontSize={"20px"} />,
      states: ["visita realizada"],
    },
    {
      title: "Análise de crédito",
      icon: <BsBank fontSize={"20px"} />,
      states: ["em análise de crédito", "análise de crédito realizada"],
    },
    {
      title: "Cotação",
      icon: <MdChecklist fontSize={"20px"} />,
      states: [
        "proposta",
        "proposta aprovada",
        "proposta reprovada",
        "análise safi",
        "aprovado safi",
        "rejeitado safi",
      ],
    },
    {
      title: "Contrato",
      icon: <IoDocumentTextOutline fontSize={"20px"} />,
      states: [
        "contrato gerado",
        "contrato comunicado",
        "contrato com pendência comercial",
      ],
    },
    {
      title:
        currentFase?.toLowerCase() === "fechado e perdido"
          ? "Fechado e Perdido"
          : "Fechado e Ganho",
      icon: <></>,
      states:
        currentFase?.toLowerCase() === "fechado e perdido"
          ? ["fechado e perdido"]
          : ["fechado e ganho"],
    },
  ];

  // useEffect(() => {
  //   if (accessQuote.nomeDaCotacao === "") {
  //     setIndex(0);
  //   }
  // }, [accessQuote]);

  const handleGetOportunity = async () => {
    setloadingGetOportunity(true);
    try {
      const response = await oportunityServiceInstance.getOportunityById({
        OportunidadeId: accessCreateOp.oportunidadeId,
      });

      if (!response) {
        setloadingGetOportunity(false);
        displayMessageError({
          message: "Não foi possível carregar os dados da oportunidade",
        });
        setRanking("");
        console.log("status 204", response);
        return;
      }

      if (response.status === 401) {
        setloadingGetOportunity(false);
        return;
      }

      if (response.status >= 400 && response?.status !== 401) {
        setloadingGetOportunity(false);
        displayMessageError({
          message: "Erro ao carregar os dados da oportunidade.",
        });
        console.log("status 400", response);
        setRanking("");
        return;
      }

      setAllowedDrop(response?.PermitidoQueda);
      setProbabilidade(response.probabilidade);
      setRanking(response?.ranking);
      setTelephoneOp(response?.telefonePrincipal);
      setEmailOp(response?.emailPrincipal);
      setRegionalOp(response?.regional);
      setDisabledCreateDocument(response?.contaPossuiCPF);
      setCurrentFase(response.fase);
      setFaseOp(
        response?.fase?.toLocaleLowerCase() === "fechado e ganho" ||
          response?.fase?.toLocaleLowerCase() === "fechado e perdido",
      );
      setloadingGetOportunity(false);
    } catch (error) {
      setloadingGetOportunity(false);
      console.log("ErrorHandleGetOportunityById", error);
    }
  };

  const handleUpdateOportunity = async () => {
    setLoadingCloseLose(true);

    try {
      const payload = {
        opportunityIdSalesforce: accessCreateOp.oportunityIdSalesforce,
        OportunidadeId: accessCreateOp.oportunidadeId,
        accountIdSalesforce: accountIdSalesforce,
        motivoQueda: reasonNumber,
      };

      const response =
        await oportunityServiceInstance.updateOportunity(payload);

      if (response.success === false) {
        setLoadingCloseLose(false);
        displayMessageError({ message: response.err });
        setAccessCreateOp({ ...accessCreateOp });
        return;
      }

      displayMessage("Oportunidade editada com sucesso!");
      setAccessCreateOp({ ...accessCreateOp });
      setLoadingCloseLose(false);
      setShowCloseLose(false);
      handleGetOportunity();
      setUpdateData({ data: "any" });
    } catch (error) {
      setLoadingCloseLose(false);
      console.log("ErrorHandleUpdateOportunityById", error);
    }
  };

  const handleCreateTask = async () => {
    setLoadingCreateCall(true);
    setSuccessCreateTaskCall(false);

    const getDateToDay = () => {
      const today = new Date();
      today.setDate(today.getDate());
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${day}/${month}/${year}`;
    };

    try {
      const response = await oportunityServiceInstance.createTask({
        idCorretorSalesforce: idCorretor,
        assunto: "Chamada",
        dataDeVencimento: `${getDateToDay()}`,
        relativoA: accessCreateOp.oportunityIdSalesforce,
        status: "Concluído",
        tipoDeRegistro: "Call",
        numeroDeTentativas: 1,
        comentarios:
          "Chamada criada automaticamente pelo corretor, através do botão de whatsapp do cliente no Bora Vender.",
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingCreateCall(false);
        displayMessageError({
          message: response?.data?.mensagem
            ? response?.data?.mensagem
            : `Erro ao criar chamada!`,
        });
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoadingCreateCall(false);
        // setIsUnauthorized(true);
        return;
      }

      setAccessTasksCalls({
        idTarefaSalesforce: response?.id,
        tipoDeRegistro: response?.tipoDeRegistro,
      });

      setCreateTaskOrCall("Chamada");
      displayMessageCreateCall({
        title: `Chamada registrada com sucesso!`,
        message:
          "A nova atividade foi criada e você já pode acessar para continuar sua venda.",
        titleButton: `Acessar chamada`,
        onClick: () => {
          setShowDetailTaskCall(true);
          setSuccessCreateTaskCall(false);
        },
      });
      setSuccessCreateTaskCall(true);
      setLoadingCreateCall(false);
    } catch (error) {
      setLoadingCreateCall(false);
      console.log("errorHandleCreateTask", error);
    }
  };

  const handleUpdateRank = async () => {
    setLoadingUpdaterank(true);

    try {
      const response = await oportunityServiceInstance.updateRank({
        cpfCnpj,
        idOportunidade: accessCreateOp.oportunityIdSalesforce,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingUpdaterank(false);
        displayMessageError({
          message: response.err.mensagem
            ? response.err.mensagem
            : `Erro ao atualizar o ranking, por favor tente novamente mais tarde!`,
        });
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoadingUpdaterank(false);
        // setIsUnauthorized(true);
        return;
      }

      if (response.sucesso === false) {
        displayMessageError({
          message: response?.err
            ? response?.err
            : `Erro ao atualizar o ranking, por favor tente novamente mais tarde!`,
        });
        setLoadingUpdaterank(false);
        return;
      }

      if (response?.message?.includes("atualizado com sucesso")) {
        setHashRanking("Update");
        setNewRanking(response?.novoRanking);
      } else {
        setHashRanking("NotUpdate");
      }

      // displayMessage("Oportunidade editada com sucesso!");
      setLoadingUpdaterank(false);
    } catch (error) {
      setLoadingUpdaterank(false);
      console.log("ErrorHandleUpdateRank", error);
    }
  };

  const SalesHashMap: IHashMapKeyString = {
    DetailOportunity: (
      <>
        <Flex
          w="99%"
          h="20%"
          justifyContent="space-between"
          alignItems={{ base: "flex-start", md: "flex-start", lg: "center" }}
          mt="5px"
          flexDir={{ base: "column", md: "column", lg: "row" }}
        >
          <Box display="flex" flexDirection="column" gap={"8px"}>
            <Heading
              as="h1"
              fontSize="26px"
              fontWeight="500"
              color={theme.text}
            >
              {loadingGetOportunity
                ? ""
                : opportunityName ||
                  accessCreateOp?.nomeDaConta?.toUpperCase()}{" "}
              ({opportunityId || accessCreateOp.oportunidadeId}){" "}
            </Heading>

            {loadingGetOportunity ? null : (
              <Flex
                flexDir={{ base: "column", sm: "column", md: "row" }}
                fontSize={"14px"}
                color={theme.text50}
                gap={"14px"}
                mb={{ base: "5px", sm: "5px", md: "0px" }}
              >
                {ranking && (
                  <Box
                    display={"flex"}
                    w={"fit-content"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    gap={"6px"}
                    // onClick={() => setOpenModalRanking(true)}
                  >
                    {ranking === "Ranking não disponível" ? (
                      <IconUnranked
                        color={"#59667A"}
                        width={"17"}
                        height={"17"}
                      />
                    ) : (
                      <FaAward
                        color={handleDefaultRanking(ranking)}
                        fontSize={"18px"}
                      />
                    )}

                    <Text minW={"fit-content"}>
                      {ranking === "Ranking não disponível"
                        ? ranking
                        : `Cliente ${ranking}`}
                    </Text>
                  </Box>
                )}

                {emailOp && (
                  <Box
                    display={"flex"}
                    w={"fit-content"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    gap={"6px"}
                    cursor="pointer"
                    onClick={() => {
                      navigator.clipboard.writeText(emailOp);
                      displayMessage("Email copiado!");
                    }}
                  >
                    <IconMail width="14px" height="14px" />
                    <Text
                      minW={"fit-content"}
                      _hover={{ color: theme.primary }}
                    >
                      {emailOp}
                    </Text>
                  </Box>
                )}

                {telephoneOp && (
                  <Box
                    display={"flex"}
                    w={"fit-content"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    gap={"6px"}
                  >
                    {loadingCreateCall ? (
                      <Box h={"15px"}>
                        <Spinner size="sm" />
                      </Box>
                    ) : (
                      <>
                        <Box w={"fit-content"}>
                          <IconCall width="14px" height="14px" />
                        </Box>
                        <Text
                          minW={"fit-content"}
                          _hover={{ color: theme.primary }}
                          onClick={handleCreateTask}
                        >
                          <a
                            href={`https://web.whatsapp.com/send?phone=${telephoneOp?.replace(
                              /\D/g,
                              "",
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            {telephoneOp}
                          </a>
                        </Text>
                      </>
                    )}
                  </Box>
                )}
              </Flex>
            )}
          </Box>

          <Flex
            w={{
              base: "100%",
              sm: "100%",
              md: "100%",
              lg: "50%",
              "2xl": "35%",
            }}
            gap="8px"
            justifyContent="flex-end"
            mt={{ base: "0px", md: "10px", lg: "0px" }}
            mb={{ base: "60px", md: "0px", lg: "0px" }}
          >
            <Box w={"48px"}>
              <Button
                title={
                  <Icon
                    display={"flex"}
                    alignItems="center"
                    justifyContent="center"
                    fontSize={"22px"}
                    w={"16px"}
                    h={"auto"}
                  >
                    <RxUpdate />
                  </Icon>
                }
                disabled={faseOp}
                onClick={() => {
                  setUpdateData({ data: "any" });
                  handleGetOportunity();
                  setLoading(true);
                  setOnboardingDocuments([]);
                  oportunityServiceInstance
                    .getOnboardingDocuments({
                      CodigoRelacionamentoComComprador:
                        accessAttachments.codigoRelacionamentoComComprador,
                      CPF: accessAttachments.cpf,
                    })
                    .then((d) => {
                      setOnboardingDocuments(d);
                      setLoading(false);
                    });

                  oportunityServiceInstance
                    .getContracts({
                      opportunityIdSalesforce:
                        accessCreateOp.oportunityIdSalesforce,
                    })
                    .then((c) => {
                      setContracts(c);
                      setLoading(false);
                    });
                }}
              />
            </Box>
            <Flex
              display={"flex"}
              gap="8px"
              // w={index === 0 ? "60%" : "30%"}
              w={{
                base: index === 0 ? "60%" : "30%",
                md: index === 0 ? "30%" : "30%",
                lg: index === 0 ? "60%" : "30%",
                "2xl": index === 0 ? "60%" : "30%",
              }}
            >
              {index === 0 && (
                <Box maxW={"140px"}>
                  <Button
                    title={"Editar dados"}
                    onClick={() => {
                      setEdit(true);
                      setCancelButtonAdress(false);
                    }}
                    disabled={edit || faseOp || loadingGetOportunity}
                  />
                </Box>
              )}

              <Box maxW={"110px"}>
                <ButtonPopover
                  disabled={faseOp || loadingGetOportunity}
                  title={"Opções"}
                  popoverContent={arrayButtons
                    // filtra os botões antes de renderizar
                    .filter(
                      (button) =>
                        !(
                          button.title === "Fechar e perder oportunidade" &&
                          allowedDrop === false
                        ),
                    )
                    .map((button) => (
                      <Box w="100%" key={button.title}>
                        <Flex
                          flexDir={"column"}
                          w="100%"
                          justifyContent={"center"}
                        >
                          <Box
                            display={"flex"}
                            p={"10px"}
                            gap={"15px"}
                            alignItems={"center"}
                            opacity={"0.8"}
                            _hover={{ opacity: "1" }}
                            cursor="pointer"
                            onClick={button.onClick}
                          >
                            <Box w={"fit-content"} color={theme.text}>
                              {button.icon}
                            </Box>
                            <Text
                              w={"fit-content"}
                              fontSize={"13px"}
                              fontWeight={"medium"}
                              color={theme.text}
                              _hover={{ color: theme.primary }}
                            >
                              {button.title}
                            </Text>
                          </Box>

                          <Divider
                            orientation="horizontal"
                            borderColor={"#E5E9F0"}
                            h={"2px"}
                          />
                        </Flex>
                      </Box>
                    ))}
                />
              </Box>
            </Flex>

            {/* {allowedDrop && (
              <Flex>
                <Button
                  title={"Fechar e perder"}
                  onClick={() => {
                    setShowCloseLose(true);
                  }}
                  error
                />
              </Flex>
            )} */}
          </Flex>
        </Flex>

        <Box
          display={"flex"}
          flexDirection={"column"}
          w="100%"
          bg={"white"}
          borderRadius="8px"
          mt="8px"
          justifyContent={"center"}
        >
          {loadingGetOportunity ? (
            <Flex
              flexDirection={"column"}
              w="100%"
              h={"150px"}
              bg={"white"}
              borderRadius="8px"
              mt="8px"
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Spinner />
            </Flex>
          ) : (
            <Box
              display={"flex"}
              flexDirection={"column"}
              w="100%"
              h={"150px"}
              bg={"white"}
              borderRadius="8px"
              mt="10px"
              justifyContent={"center"}
              alignItems={"center"}
              p={"8px"}
            >
              {/* <Text w={"100%"} fontSize={"11px"} color={theme.text}>Acompanhamento da oportunidade:</Text> */}

              <Flex alignItems="center" gap="10px" w={"99%"}>
                <Text w={"fit-content"} fontWeight={"medium"} fontSize={"14px"}>
                  {dataOportunidade}
                </Text>
                <Divider
                  orientation="horizontal"
                  borderColor={"#e5e9f0"}
                  h={"2px"}
                  flex="1"
                  rounded={"8px"}
                />
              </Flex>

              <Box
                display={"flex"}
                flexDirection={"column"}
                w="100%"
                mt="20px"
                pl={{ base: "10px", sm: "10px", md: "20px" }}
                justifyContent={"center"}
                alignItems={"center"}
                overflow={{ base: "auto", sm: "auto", md: "none" }}
              >
                <Stepp
                  steps={steps}
                  activeStep={currentFase}
                  progressPercent={probabilidade ? Number(probabilidade) : 0}
                />
              </Box>
            </Box>
          )}
        </Box>

        <Box
          display={"flex"}
          w="100%"
          bg={"white"}
          borderRadius="8px"
          p="4px"
          gap={"6px"}
          mt={"15px"}
        >
          <Tab
            widthXl="100%"
            width="100%"
            widthMd="100%"
            widthSm="100%"
            widthBase="100%"
            index={index}
            setIndex={setIndex}
            tabLabels={tabLabels}
            tabContents={tabContents}
            disabled={loadingGetOportunity}
          />
        </Box>
      </>
    ),

    ViewCreditRatingComponent: <ViewCreditRatingComponent hash={hash} />,

    ViewQuotesComponent: (
      <ViewQuotesComponent
        hash={hash}
        isEdit={isEditQuote}
        setIsEdit={setIsEditQuote}
        canEdit={canEditQuote}
      />
    ),
  };

  const RankingHashMap: IHashMapKeyString = {
    Inicial: (
      <>
        <Flex alignItems={"center"} justifyContent={"center"} pb={"15px"}>
          <Box
            display={"flex"}
            w={"60px"}
            h={"60px"}
            bg={theme.disable100}
            borderRadius={"full"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <FaAward color={handleDefaultRanking(ranking)} fontSize={"26px"} />
          </Box>
        </Flex>

        <Flex flexDir={"column"} align={"center"}>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            pb={"15px"}
          >
            <Text w={"fit-content"} fontSize={"20px"} fontWeight={"semibold"}>
              Consultar status CPF
            </Text>
          </Box>

          <Box w={"280px"} textAlign={"center"}>
            <Text fontSize={"14px"} color={theme.text50}>
              O status de {opportunityName || accessCreateOp?.nomeDaConta} no
              ranking é{" "}
              <strong>
                {ranking === null
                  ? "vazio"
                  : ranking === "Ranking não disponível"
                    ? "não disponível"
                    : ranking}
              </strong>
              . Para verificar se há alguma atualização, faça uma consulta
              abaixo.
            </Text>
          </Box>
        </Flex>
      </>
    ),
    Update: (
      <>
        <Flex alignItems={"center"} justifyContent={"center"} pb={"15px"}>
          <Box
            display={"flex"}
            w={"60px"}
            h={"60px"}
            bg={theme.disable100}
            borderRadius={"full"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <FaAward
              color={handleDefaultRanking(newRanking)}
              fontSize={"26px"}
            />
          </Box>
        </Flex>

        <Flex flexDir={"column"} align={"center"}>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            pb={"15px"}
          >
            <Text
              w={"fit-content"}
              fontSize={"20px"}
              textAlign={"center"}
              fontWeight={"semibold"}
            >
              Ranking atualizado para{" "}
              {newRanking === null ? "vazio" : newRanking}
            </Text>
          </Box>

          <Box w={"280px"} textAlign={"center"}>
            <Text fontSize={"14px"} color={theme.text50}>
              {newRanking === null ? (
                "Esta conta/oportunidade não tem mais um ranking disponível."
              ) : (
                <>
                  Após consulta por CPF, o status de{" "}
                  {opportunityName || accessCreateOp?.nomeDaConta} no ranking
                  foi atualizado de <strong>{ranking}</strong> para{" "}
                  <strong>{newRanking}</strong>.
                </>
              )}
            </Text>
          </Box>
        </Flex>
      </>
    ),
    NotUpdate: (
      <>
        <Flex alignItems={"center"} justifyContent={"center"} pb={"15px"}>
          <Box
            display={"flex"}
            w={"60px"}
            h={"60px"}
            bg={theme.disable100}
            borderRadius={"full"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <FaAward color={handleDefaultRanking(ranking)} fontSize={"26px"} />
          </Box>
        </Flex>

        <Flex flexDir={"column"} align={"center"}>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            pb={"15px"}
          >
            <Text w={"fit-content"} fontSize={"20px"} fontWeight={"semibold"}>
              Sem atualizações no ranking
            </Text>
          </Box>

          <Box w={"280px"} textAlign={"center"}>
            <Text fontSize={"14px"} color={theme.text50}>
              Após consulta por CPF, o status de{" "}
              {opportunityName || accessCreateOp?.nomeDaConta} no ranking
              continua <strong>{ranking === null ? "vazio" : ranking}</strong>.
            </Text>
          </Box>
        </Flex>
      </>
    ),
    NotRanking: (
      <>
        <Flex alignItems={"center"} justifyContent={"center"} pb={"15px"}>
          <Box
            display={"flex"}
            w={"60px"}
            h={"60px"}
            bg={theme.disable100}
            borderRadius={"full"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <FaAward color={"#E0E0E0"} fontSize={"26px"} />
          </Box>
        </Flex>

        <Flex flexDir={"column"} align={"center"}>
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            pb={"15px"}
          >
            <Text w={"fit-content"} fontSize={"20px"} fontWeight={"semibold"}>
              Ranking não disponível
            </Text>
          </Box>

          <Box w={"280px"} textAlign={"center"}>
            <Text fontSize={"14px"} color={theme.text50}>
              {opportunityName || accessCreateOp?.nomeDaConta}{" "}
              <strong>ainda não possui um ranking</strong> ou não permitiu a
              consulta por CPF.
            </Text>
          </Box>
        </Flex>
      </>
    ),
  };

  React.useEffect(() => {
    if (routeState?.hashDetailOportunity === "ViewQuotesComponent") {
      setHash(routeState?.hashDetailOportunity);
      setAccessQuote({
        nomeDaCotacao: routeState?.nomeDaCotacao,
        idCotacaoSalesforce: routeState?.idCotacaoSalesforce,
      });
    }
  }, [
    routeState?.hashDetailOportunity,
    routeState?.idCotacaoSalesforce,
    routeState?.nomeDaCotacao,
    setAccessQuote,
    setHash,
  ]);

  return (
    <>
      <CkModal
        onClose={() => {
          setOpenModalRanking(false);
          setHashRanking("Inicial");
        }}
        isOpen={openModalRanking}
        isCentered
        size={"xs"}
      >
        <ModalOverlay />
        <ModalContent minH={"350px"}>
          <ModalCloseButton />
          <ModalBody
            display={"flex"}
            flexDir={"column"}
            justifyContent={"flex-end"}
          >
            <Flex flexDir={"column"} gap={"10px"}>
              {RankingHashMap[hashRanking]}
            </Flex>
          </ModalBody>
          <ModalFooter>
            {hashRanking === "Inicial" ? (
              <Button
                onClick={handleUpdateRank}
                title={loadingUpdateRank ? <Spinner /> : "Consultar status CPF"}
                disabled={loadingUpdateRank}
              />
            ) : hashRanking === "Update" ? (
              <Button
                onClick={() => {
                  setHashRanking("Inicial");
                  setOpenModalRanking(false);
                  handleGetOportunity();
                  setUpdateData({ data: "any" });
                }}
                title="Concluir"
              />
            ) : (
              <Button
                onClick={() => {
                  setHashRanking("Inicial");
                  setOpenModalRanking(false);
                }}
                title="Concluir"
              />
            )}
          </ModalFooter>
        </ModalContent>
      </CkModal>

      <Modal
        isCloseLose
        subtitleImportant
        onOpen={showCloseLose}
        title={`Deseja fechar e perder a ${accessCreateOp.oportunidadeId}?`}
        subtitle="*Ao clicar em Fechar e perder, você deve estar ciente que este processo é irreversível."
        onClose={() => {
          setShowCloseLose(false);
          setReason("");
        }}
        minH="250px"
      >
        <Flex flexDir={"column"} justify={"space-between"} minH={"160px"}>
          <Flex w={"80%"}>
            <InputSelect
              isRequirement
              widht="70%"
              height="44%"
              title="Motivo (obrigatório)"
              label={reason || "Selecione uma opção"}
              isSelected={reason}
              options={optionCloseLose}
              selectedOption={reason}
              onChange={(e) => {
                setReason(e.currentTarget.value);
                setReasonNumber(Number(e.currentTarget.id) + 1);
              }}
            />
          </Flex>

          <Flex
            p={"5px"}
            justify={"space-between"}
            align={"center"}
            gap={"10px"}
            w={"80%"}
          >
            <Button
              title="Cancelar"
              onClick={() => {
                setShowCloseLose(false);
                setReason("");
              }}
            />

            <Button
              title={loadingCloseLose ? <Spinner /> : "Fechar e perder"}
              onClick={handleUpdateOportunity}
              disabled={!reason || loadingCloseLose}
              colorError
            />
          </Flex>
        </Flex>
      </Modal>

      <Modal
        onOpen={modalSchedule}
        title="Criar agendamento"
        subtitle="Preencha as informações para registro e acompanhamento no sistema."
        onClose={() => setModalSchedule(false)}
      >
        <CreateScheduleComponent
          onBack={() => setModalSchedule(false)}
          setSuccessCreateSchedule={setSuccessCreateSchedule}
          setShowDetailSchedule={setShowDetailSchedule}
        />
      </Modal>

      <Modal
        onOpen={modalTaskCall}
        title="Criar atividade da oportunidade"
        subtitle="Preencha as informações para registro e acompanhamento no sistema."
        onClose={() => setModalTaskCall(false)}
      >
        <CreateTaskCallComponent
          onBack={() => setModalTaskCall(false)}
          setSuccessCreateTaskCall={setSuccessCreateTaskCall}
          setShowDetailTaskCall={setShowDetailTaskCall}
        />
      </Modal>

      <Modal
        onOpen={modalCreditRating}
        title="Criar avaliação de crédito"
        subtitle="Preencha as informações que serão enviadas para o correspondente bancário realizar a análise de crédito."
        onClose={() => setModalCreditRating(false)}
      >
        <CreateCreditRatingComponent
          onBack={() => setModalCreditRating(false)}
          setSuccessCreateCreditRating={setSuccessCreateCreditRating}
          setHash={setHash}
        />
      </Modal>

      <Modal
        onOpen={modalQuot}
        title="Criar cotação"
        // subtitle="Preencha as informações para registro e acompanhamento no sistema."
        onClose={() => setModalQuot(false)}
        size={hashCreateQuote === "SelectUnity" ? "6xl" : "3xl"}
        minH="300px"
        isCentered
      >
        <CreateQuotesComponent
          onBack={() => setModalQuot(false)}
          setSuccessCreateQuote={setSuccessCreateQuote}
          setIsEdit={setIsEditQuote}
          setHash={setHash}
        />
      </Modal>

      {SalesHashMap[hash]}
    </>
  );
};
